import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";
import { Tag } from "./models";

export function reduceString(text: string, length = 10): string {
  return text.length > length ? text.substring(0, length - 3) + "..." : text;
}

export function titleCase(text: string): string {
  return startCase(camelCase(text));
}

export function removeFromIndex<T>(array: T[], index: number): T[] {
  if (index < 0 || index >= array.length) {
    return array;
  }

  let o = [...array];
  return o.splice(index, 1);
}

export function formatAmount(num: any) {
  const n = String(num),
    p = n.indexOf(".");
  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) =>
    p < 0 || i < p ? `${m},` : m
  );
}

export function putCommas(numberString: string) {
  if (numberString.length < 4) {
    return numberString;
  }
  const numberPattern = /^\d+$/;
  const chars = numberString.split("");
  const len = chars.length - 1;
  let counter = 0;
  const numberWithCommas = [];
  for (let i = len; i > -1; i--) {
    if (counter > 0 && counter % 3 === 0) {
      numberWithCommas.push(",");
    }
    if (numberPattern.test(chars[i])) {
      numberWithCommas.push(chars[i]);
      counter++;
    }
  }
  return numberWithCommas.reverse().join("");
}

export function to2DecimalPlaces(
  numString: string | number,
  withCommas = false
): string {
  let _number =
    typeof numString === "string" ? parseFloat(numString) : numString;
  _number = Math.round((_number + Number.EPSILON) * 100) / 100;
  const ans = _number.toFixed(2);
  if (!withCommas) {
    return ans;
  } else {
    const values = ans.split(".");
    if (values.length === 1) {
      return values[0];
    }
    return `${putCommas(values[0])}.${values[1]}`;
  }
}

export function getAppointmentPrice(specialization: Tag) {
  if (specialization.value && specialization.value.val) {
    return specialization.value.val.appointmentPrice;
  }
  return 5000;
}
export function getSpecializationDescription(specialization: Tag) {
  if (specialization.value && specialization.value.val) {
    return specialization.value.val.description || "None";
  }
  return "None";
}
